import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import icon from '../images/megaphone.png';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import PropTypes from 'prop-types';

//redux
import { connect } from 'react-redux';
import { loginUser } from '../redux/actions/userActions';


const Link = require('react-router-dom').Link;
const styles = (theme) => ({
    ...theme.spread
});

export class login extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            errors: {}
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();

        const userData = {
            email: this.state.email,
            password: this.state.password
        };

        this.props.loginUser(userData, this.props.history);

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.UI.errors) {
            this.setState({ errors: nextProps.UI.errors });
        }
    }

    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        this.setState(() => {
            return {
                [name]: value
            }
        }, () => console.log(this.state))
    }
    render() {
        window.s = this.state;
        console.log(this.props)

        const {
            classes,
            UI: { loading }
        } = this.props;
        const { errors } = this.state;
        console.log(this.props)
        return (
            <Grid container className={classes.form}>
                <Grid item sm />
                <Grid item sm>
                    <img className={classes.image} src={icon} alt='login' Width='100px' />
                    <Typography className={classes.pageTitle} variant='h2' >
                        Login
                    </Typography>
                    <form noValidate onSubmit={this.handleSubmit} >
                        <TextField id='email' name='email' type='email' label='Email' className={classes.TextField} value={this.state.email}
                            helperText={errors.email} error={errors.email ? true : false} onChange={this.handleChange} fullWidth
                        />
                        <TextField id='password' name='password' type='password' label='Password' className={classes.TextField} value={this.state.password}
                            helperText={errors.password} error={errors.password ? true : false} onChange={this.handleChange} fullWidth
                        />
                        {errors.error === 'auth/invalid-email' ? (
                            <Typography variant='body2' className={classes.customError}>
                                Invalid credentials!
                            </Typography>
                        ) : null}
                        <Button disabled={loading} type='submit' variant='contained' color='primary' className={classes.button}>Login {loading && (<CircularProgress size={30} className='' />)}</Button>
                        <br />
                        <small>
                            dont have an account? sign up <Link to='/signup'>here</Link>
                        </small>
                    </form>
                </Grid>
                <Grid item sm />
            </Grid>
        )
    }
}

login.propTypes = {

    loginUser: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    user: state.user,
    UI: state.UI
});

const mapActionsToProps = {
    loginUser
};

export default connect(
    mapStateToProps,
    mapActionsToProps
)(withStyles(styles)(login));
